import { render } from "./TodoCardUpdateResumo.vue?vue&type=template&id=253ec65b"
import script from "./TodoCardUpdateResumo.vue?vue&type=script&lang=js"
export * from "./TodoCardUpdateResumo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__